import { CardSvg } from '@/play/cardSvg'

/** Home card art: a grey cratered moon under a starry sky, bright slime pouring onto it. */
export function MoonSlimeCardArt() {
  const stars = [[24, 22], [62, 48], [98, 16], [140, 36], [176, 12], [214, 30], [252, 18], [292, 44], [120, 64], [44, 70], [270, 74], [196, 58]]
  return (
    <CardSvg bg="#070915">
      {stars.map(([x, y], i) => <circle key={i} cx={x} cy={y} r={i % 3 === 0 ? 1.8 : 1.1} fill="#f4f6ff" />)}
      <circle cx="262" cy="46" r="14" fill="#3f8cff" />
      <path d="M0 132 C 60 118, 120 124, 170 120 S 270 116, 320 126 V 200 H 0 Z" fill="#a9abb1" />
      <ellipse cx="96" cy="150" rx="44" ry="11" fill="#8c8e95" />
      <ellipse cx="96" cy="146" rx="44" ry="8" fill="none" stroke="#b8babf" strokeWidth="3" />
      <ellipse cx="238" cy="168" rx="26" ry="7" fill="#8c8e95" />
      {/* slime: a mound in the crater, and a fat rope drifting down onto a spreading heap */}
      <path d="M78 150 C 78 134, 112 134, 112 150 Z" fill="#6dff3a" />
      <path d="M200 30 C 194 60, 206 90, 200 118 C 198 126, 204 132, 204 136 L 218 136 C 218 130, 222 124, 220 116 C 216 90, 226 60, 220 30 C 216 24, 204 24, 200 30 Z" fill="#2ef2ff" />
      <path d="M176 142 C 180 128, 196 122, 211 122 S 244 128, 248 142 Z" fill="#2ef2ff" />
      <ellipse cx="205" cy="52" rx="3" ry="9" fill="#ffffff" opacity="0.55" />
    </CardSvg>
  )
}
